import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DrawerPage } from './drawer';
import { ComponentsModule } from '../../components/components.module';
import { EstudosCientificosPageModule } from '../estudos-cientificos/estudos-cientificos.module';
import { SolicitacaoContatoPageModule } from '../solicitacao-contato/solicitacao-contato.module';
import { EventosPageModule } from '../eventos/eventos.module';
import { ProdutosPageModule } from '../produtos/produtos.module';
import { DuvidasSugestoesPageModule } from '../duvidas-sugestoes/duvidas-sugestoes.module';
import { EventoAdversoPageModule } from '../evento-adverso/evento-adverso.module';
import { RepresentantePageModule } from '../representante/representante.module';

@NgModule({
  declarations: [
    DrawerPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(DrawerPage),
    EstudosCientificosPageModule,
    SolicitacaoContatoPageModule,
    EventosPageModule,
    ProdutosPageModule,
    EventosPageModule,
    DuvidasSugestoesPageModule,
    EventoAdversoPageModule,
    RepresentantePageModule
  ],
  entryComponents: [
  ]
})
export class DrawerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/drawer/drawer.module.ts